module.exports = __webpack_public_path__ + "d1876a45cd465c4e3be6696a47feea2a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg81.jpeg
// module id = 96
// module chunks = 0